// extracted by mini-css-extract-plugin
module.exports = {"image":"HomePageContent_image__26vv3"};